module.exports = __webpack_public_path__ + "static/dstevens-1b068522ec21cef28265a72ed01264b7.png";